import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TimesheetAndExpensesService } from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { TimesheetAndExpensesComponent } from './components/timesheet-and-expenses/timesheet-and-expenses.component';

@Injectable({
    providedIn: 'root',
})
export class TimesheetCanDeactivateGuard implements CanDeactivate<TimesheetAndExpensesComponent> {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly timesheetAndExpensesService: TimesheetAndExpensesService,
    ) {}

    public canDeactivate(
        /* eslint-disable @typescript-eslint/no-unused-vars */
        component: TimesheetAndExpensesComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        this.log.debug(`Triggering auto-save of timesheet`);
        this.timesheetAndExpensesService
            .saveAndUploadTimesheet(component.model)
            .pipe(
                take(1),
                catchError((err) => {
                    this.log.error(`Saving timesheet failed: ${JSON.stringify(err)}`);
                    return of(undefined);
                }),
            )
            .subscribe();

        return true;
    }
}
